import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withHandlers, compose, lifecycle, withProps, withStateHandlers } from 'recompose'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookModels from 'app/modules/playbook/models'
import { EditSenderLevels } from 'app/modules/playbook/constants'
import { weakUuid } from 'app/modules/playbook/helpers'
import * as UserActions from 'app/modules/user/actions'
import { isGmailConnected } from 'app/modules/user/selectors'

import Sequence from './component'

const mapStateToProps = state => ({
  sequence: PlaybookSelectors.sequence(state),
  emails: PlaybookSelectors.emails(state),
  isMarketingSequencePlaybook: PlaybookSelectors.getIsMarketingSequencePlaybook(state),
  marketingEmailLayout: PlaybookSelectors.marketingEmailLayout(state),
  isOneTimeMarketingSequencePlaybook: PlaybookSelectors.getIsOneTimeMarketingSequencePlaybook(state),
  sendTestSequencePending: PlaybookSelectors.getSendTestSequencePending(state),
  editSenderLevel: PlaybookSelectors.getEditSenderLevel(state),
  isGmailConnected: isGmailConnected(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    addEmail: PlaybookActions.addEmail,
    setMarketingEmailLayout: PlaybookActions.setMarketingEmailLayout,
    fetchGoogleScopes: UserActions.fetchGoogleScopes,
    showGoogleAuthModal: PlaybookActions.showGoogleAuthModal,
    sendTestSequence: PlaybookActions.sendTestSequence,
    setEditSenderLevel: PlaybookActions.setEditSenderLevel,
    setSenderName: PlaybookActions.setSequenceSenderName,
    setEmailOverride: PlaybookActions.setSequenceEmailOverride,
    setDynamicAccountSendAttribute: PlaybookActions.setDynamicAccountSendAttribute,
    setDynamicSenderFormat: PlaybookActions.setDynamicSenderFormat,
    setSequenceDynamicAccountSendAttribute: PlaybookActions.setSequenceDynamicAccountSendAttribute,
    setSequenceDynamicSenderFormat: PlaybookActions.setSequenceDynamicSenderFormat,
    setSequenceIndividualDynamicAttr: PlaybookActions.setSequenceIndividualDynamicAttr,
    setSequenceIndividualDynamicFormat: PlaybookActions.setSequenceIndividualDynamicFormat,
    setSequenceIndividualSenderName: PlaybookActions.setSequenceIndividualSenderName,
    setSequenceIndividualEmailOverride: PlaybookActions.setSequenceIndividualEmailOverride,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.actions.fetchGoogleScopes()

      // make sure the data is clean and the "edit sender level" toggle is correctly set
      const globalSenderIsEmpty = (
        this.props.sequence.options.get('sendFromOverride') === null &&
        this.props.sequence.options.get('senderEmailOverride') === null &&
        this.props.sequence.options.get('dynamicAccountSendAttribute') === null &&
        this.props.sequence.options.get('dynamicSenderFormat') === null
      )
      const localSenderIsEmpty = this.props.emails.reduce((emptySoFar, email) => (
        emptySoFar &&
        email.get('sendFromOverride') === null &&
        email.get('senderEmailOverride') === null &&
        email.get('dynamicAccountSendAttribute') === null &&
        email.get('dynamicSenderFormat') === null
      ), true)
      const isLocalSender = !localSenderIsEmpty
      this.props.actions.setEditSenderLevel(isLocalSender ? EditSenderLevels.LOCAL : EditSenderLevels.GLOBAL)
      if (isLocalSender && !globalSenderIsEmpty) {
        this.props.actions.setSenderName(null)
        this.props.actions.setEmailOverride(null)
        if (this.props.isMarketingSequencePlaybook) {
          this.props.actions.setSequenceDynamicAccountSendAttribute(null)
          this.props.actions.setSequenceDynamicSenderFormat(null)
        } else {
          this.props.actions.setDynamicAccountSendAttribute(null)
          this.props.actions.setDynamicSenderFormat(null)
        }
      } else if (!isLocalSender && !localSenderIsEmpty) {
        this.props.sequence.emails.forEach(emailId => {
          this.props.actions.setSequenceIndividualEmailOverride({ data: null, emailId })
          this.props.actions.setSequenceIndividualSenderName({ data: null, emailId })
          this.props.actions.setSequenceIndividualDynamicAttr({ data: null, emailId })
          this.props.actions.setSequenceIndividualDynamicFormat({ data: null, emailId })
        })
      }
    }
  }),
  withProps(props => ({
    canSelectTemplate: props.isMarketingSequencePlaybook,
  })),
  withHandlers({
    onSetEditSenderLevel: props => () => {
      const isLocal = props.editSenderLevel === EditSenderLevels.LOCAL
      if (isLocal) {
        props.actions.setEditSenderLevel(EditSenderLevels.GLOBAL)
        // wipe out local sender edits
        props.sequence.emails.forEach(emailId => {
          props.actions.setSequenceIndividualEmailOverride({ data: null, emailId })
          props.actions.setSequenceIndividualSenderName({ data: null, emailId })
          props.actions.setSequenceIndividualDynamicAttr({ data: null, emailId })
          props.actions.setSequenceIndividualDynamicFormat({ data: null, emailId })
        })
      } else {
        props.actions.setEditSenderLevel(EditSenderLevels.LOCAL)
        // wipe out the global sender edits, we're going to edit each email individually
        props.actions.setSenderName(null)
        props.actions.setEmailOverride(null)
        if (props.isMarketingSequencePlaybook) {
          props.actions.setSequenceDynamicAccountSendAttribute(null)
          props.actions.setSequenceDynamicSenderFormat(null)
        } else {
          props.actions.setDynamicAccountSendAttribute(null)
          props.actions.setDynamicSenderFormat(null)
        }
      }
    },
    onAddClick: props => () => {
      props.actions.addEmail({ email: PlaybookModels.Email({ id: weakUuid() }) })
    },
    onEmailLayoutSelect: props => type => {
      props.actions.setMarketingEmailLayout(type)
    },
    onSendTestSequence: props => () => {
      if (props.isMarketingSequencePlaybook || props.isGmailConnected) {
        props.actions.sendTestSequence()
      } else {
        props.actions.showGoogleAuthModal()
      }
    },
  }),
  withStateHandlers(
    { showTripwire: false },
    {
      setShowTripwire: () => (showTripwire) => ({ showTripwire })
    }
  )
)(Sequence)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Sequence/index.js